'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

// FloatingCTA wird erst ab scrollY > 500 sichtbar (und nur auf lg-Screens).
// Deshalb laden wir den Chunk (framer-motion-Animationen, CalendlyEmbed,
// Icons) erst, wenn der Besucher tatsächlich scrollt, identisches Verhalten,
// aber kein ungenutztes JS beim initialen Laden (v. a. mobil).
const FloatingCTA = dynamic(() => import('./FloatingCTA'), { ssr: false })

export default function FloatingCTALazy() {
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    if (window.scrollY > 0) {
      setShouldLoad(true)
      return
    }
    const onScroll = () => setShouldLoad(true)
    window.addEventListener('scroll', onScroll, { once: true, passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return shouldLoad ? <FloatingCTA /> : null
}
